module.exports = __webpack_public_path__ + "static/bg-df7a5472baa856e2b4d2e0da4fac6b48.png";